export default __webpack_public_path__ + "static/media/Group9158.6f346ebe.svg";